var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXaut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.098 4h16.128c.385 0 .74.206.932.54l4.699 8.177c.243.424.17.959-.177 1.303L16.747 26.815a1.075 1.075 0 0 1-1.512 0L2.32 14.037a1.078 1.078 0 0 1-.161-1.33L7.18 4.515C7.378 4.194 7.725 4 8.1 4zm14.045 3.65v2.295H17.55v1.59c3.226.17 5.647.869 5.665 1.706v1.745c-.018.837-2.44 1.535-5.666 1.705v3.904h-3.051V16.69c-3.228-.17-5.649-.868-5.667-1.705v-1.744c.018-.836 2.44-1.534 5.666-1.704v-1.59H9.904V7.65h12.238zm-6.12 7.842c3.444 0 6.322-.59 7.027-1.38-.597-.668-2.758-1.194-5.5-1.338v1.665a29.047 29.047 0 0 1-3.051 0v-1.666c-2.744.144-4.905.67-5.502 1.339.705.788 3.583 1.379 7.026 1.379z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXaut);
export default __webpack_public_path__ + "static/media/XAUT.6f1144056cf4c0ec5d4898c300bd7100.svg";
export { ForwardRef as ReactComponent };